<template>
	<v-card>
		<v-card-title
			class="d-flex align-center mb-4"
		>
			<v-icon
				icon="$shoppingCart"
				start
			/>
			<translate>Order Data</translate>
		</v-card-title>
		<v-card-text>
			<v-form
				ref="orderForm"
			>
				<v-row>
					<v-col>
						<v-text-field
							v-model="localOrder.reference"
							:rules="[v => /^([\d]{9,12})$/.test(v) || $gettext('Order reference is required')]"
							:label="$gettext('Order Reference')"
							required
							variant="outlined"
						/>
						<v-text-field
							v-model="localOrder.row.imei"
							:rules="[v => /^\d{15}/.test(v) || Boolean(order.row.serialNumber) || $gettext('Valid IMEI or Serial Number is required')]"
							:label="$gettext('IMEI')"
							type="number"
							:required="!order.row.serialNumber"
							variant="outlined"
						/>
						<v-text-field
							v-model="localOrder.row.serialNumber"
							:rules="[v => /^[0-9a-zA-Z]{5,20}$/.test(v) || Boolean(order.row.imei)|| $gettext('Valid Serial Number or IMEI is required')]"
							:label="$gettext('Serial Number')"
							:required="!order.row.imei"
							variant="outlined"
						/>
						<v-file-input
							v-model="orderDocument"
							show-size
							:label="$gettext('Order ID Document')"
							variant="outlined"
						/>
					</v-col>
					<v-col>
						<price-field
							v-model="localOrder.row.purchasePrice"
							:label="$gettext('Phone Purchase Price')"
							required
						/>
						<date-picker
							v-model="localOrder.row.phonePurchaseDate"
							:label="$gettext('Phone Purchase Date')"
							:rules="[v => !!v || $gettext('Phone Purchase Date is required')]"
							name="purchase_date"
							required
						/>
						<v-select
							v-model="localOrder.pointOfSaleId"
							:label="$gettext('Point of Sale')"
							:rules="[v => !!v || $gettext('Point of Sale is required')]"
							required
							:items="pointOfSales"
							item-title="name"
							item-value="id"
							variant="outlined"
						/>
						<v-text-field
							v-model="localOrder.sellerName"
							:rules="[v => !!v || !isSellerRequired || $gettext('Seller Name is required')]"
							:label="$gettext('Seller Name')"
							:required="isSellerRequired"
							variant="outlined"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-switch
							v-model="localRiskLevel"
							color="primary"
							:label="$gettext('Based on the information I have about this customer I advise the insurer to reject this insurance request')"
						/>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions class="card-actions">
			<v-btn
				variant="plain"
				@click="$emit('update:previous')"
			>
				<translate>Back</translate>
			</v-btn>
			<v-spacer />
			<v-btn
				color="primary"
				:disabled="disableSendData"
				variant="flat"
				@click="submit"
			>
				<translate>Place Order</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import axios from 'axios';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'OrderDeviceData',
	props: {
		order: {
			type: Object,
			required: true,
		},
		riskLevel: {
			type: Boolean,
			required: true,
		},
		disableSendData: {
			type: Boolean,
			required: true,
		},
	},

	emits: ['update:submit', 'update:previous', 'update:order', 'update:riskLevel', 'update:document',],

	data () {
		return {
			localOrder: this.order,
			localRiskLevel: this.riskLevel,
			pointOfSales: [{
				name: '', id: -1,
			}, ],
			orderDocument: [],
		};
	},

	computed: {
		/**
		 * Check if seller needs to be added
		 *
		 * @returns {boolean} If seller is required
		 */
		isSellerRequired: function () {
			if (this.localOrder.pointOfSaleId) {
				const pointOfSale = this.pointOfSales.find((selectedPointOfSale) => {
					return selectedPointOfSale.id === this.localOrder.pointOfSaleId;
				});

				if (pointOfSale) {
					return pointOfSale.require_seller;
				}
			}
			return true;
		}
	},

	watch: {
		order: {
			/**
			 * Watch the value passed to the component and set if changed.
			 */
			handler () {
				this.localOrder = this.order;
			},
			deep: true
		},

		localOrder: {
			/**
			 * Watch if any changes are made in the form and emit to parent
			 */
			handler () {
				this.$emit('update:order', this.order);
			},
			deep: true
		},

		riskLevel () {
			this.localRiskLevel = this.riskLevel;
		},

		localRiskLevel () {
			this.$emit('update:riskLevel', this.localRiskLevel);
		}
	},


	/**
	 * Get all the necessary data from the api.
	 *
	 * @returns {void}
	 */
	created () {
		this.getPointOfSales();
	},

	methods: {
		/**
		 * Submit
		 */
		async submit () {
			const {
				valid
			} = await this.$refs.orderForm.validate();

			if (valid) {
				if (this.orderDocument.length > 0) {
					await this.$emit('update:document', this.clientDocument[0]);
				}
				this.$emit('update:submit', this.order);
			}
		},

		/**
		 * Get point of sales
		 *
		 * @returns {void}
		 */
		getPointOfSales () {
			axios.get('add/pointofsales')
				.then(({
					data
				}) => {
					this.pointOfSales = data;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during get point of sales request'));
				});
		},
	}
};
</script>
